import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCpk2uFXIkKbE_uqxhOuq42hEXIJ7dMLCE",
  authDomain: "chat-e118e.firebaseapp.com",
  projectId: "chat-e118e",
  storageBucket: "chat-e118e.appspot.com",
  messagingSenderId: "71156705994",
  appId: "1:71156705994:web:30dbd6dc1d8cf34870a233"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore()
